import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrepCook = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#F84E10",
			d: "M29.09 1.085a4.445 4.445 0 0 1 5.82 0L37.127 3a4.45 4.45 0 0 0 3.912.97l2.848-.66a4.46 4.46 0 0 1 5.154 2.722l1.078 2.734a4.48 4.48 0 0 0 3.016 2.689l2.827.747a4.49 4.49 0 0 1 3.306 4.82l-.308 2.925a4.51 4.51 0 0 0 1.429 3.791l2.157 1.984a4.515 4.515 0 0 1 .702 5.814l-1.623 2.446a4.52 4.52 0 0 0-.486 4.025l.994 2.766a4.51 4.51 0 0 1-2.063 5.476l-2.567 1.407a4.5 4.5 0 0 0-2.289 3.336l-.397 2.914c-.3 2.2-2.15 3.85-4.356 3.884l-2.922.045a4.46 4.46 0 0 0-3.568 1.884l-1.697 2.395a4.45 4.45 0 0 1-5.65 1.401l-2.61-1.326a4.44 4.44 0 0 0-4.029 0l-2.608 1.326a4.45 4.45 0 0 1-5.65-1.401l-1.698-2.395a4.46 4.46 0 0 0-3.567-1.884l-2.923-.045a4.476 4.476 0 0 1-4.356-3.884l-.397-2.914a4.5 4.5 0 0 0-2.289-3.337L3.93 46.25a4.51 4.51 0 0 1-2.063-5.476l.994-2.766a4.52 4.52 0 0 0-.486-4.025L.752 31.537a4.515 4.515 0 0 1 .702-5.814L3.61 23.74a4.51 4.51 0 0 0 1.429-3.79l-.308-2.926a4.49 4.49 0 0 1 3.306-4.82l2.827-.747a4.48 4.48 0 0 0 3.016-2.689l1.078-2.734a4.46 4.46 0 0 1 5.154-2.721l2.848.66a4.45 4.45 0 0 0 3.912-.97z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 24,
			fill: "#FE8356"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 20,
			fill: "#DA3C03"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFA98D",
			fillRule: "evenodd",
			d: "M39.707 22.293a1 1 0 0 0-1.414 0l-12 12-.011.01-4.489 4.49a2.414 2.414 0 1 0 3.414 3.414L29 38.414l2.793 2.793a1 1 0 0 0 1.447-.034c1.398-1.538 3.329-3.794 5.316-6.117l.004-.005 1.2-1.4c3.375-3.938 2.277-9.028-.053-11.358M27.586 37 27 36.414l-3.793 3.793a.414.414 0 1 0 .586.586zm4.875 2.047L28.414 35 38.92 24.496c1.223 1.918 1.593 5.203-.678 7.853l-1.211 1.414-.001.002c-1.67 1.95-3.28 3.832-4.568 5.282",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgPrepCook);
export default ForwardRef;
